<template>
  <div id="app">
    <Navbar />
    <transition name="fade">
      <router-view />
    </transition>
    <Footer />
    <!-- <div v-if="show" class="loader">
      <span class="loader-out">
        <img src="./assets/img/zespri-logo.png" alt="">
      </span>
    </div> -->
  </div>
</template>

<script>
import Navbar from '@/components/shared/Navbar';
import Footer from '@/components/shared/Footer';
export default {
  name: 'app',
  components: {
    Navbar,
    Footer
  },
  data: function () {
    return {
      show: false
    }
  },
  mounted() {
    // this.$router.beforeEach((to, from, next) => {
    //   this.show = true;

    //   setTimeout(() => {
    //     window.scrollTo(0,0);
    //     next();
    //   },1000);

    //   setTimeout(() => {
    //     this.show = false;
    //   },2000);
    // });
  },
  watch: {
        '$route': function(){
            window.scrollTo(0,0);
        }
  }
}
</script>
